const normalizeToken = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value)
    .trim()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_")
    .toUpperCase();
};

export const normalizeCheckInStatus = (value) => {
  const normalized = normalizeToken(value);

  if (["CHECKED_IN", "CHECKEDIN"].includes(normalized)) {
    return "CHECKED_IN";
  }

  if (["NOT_CHECKED_IN", "NOTCHECKEDIN"].includes(normalized)) {
    return "NOT_CHECKED_IN";
  }

  return normalized;
};

export const normalizeYesNo = (value) => {
  if (value === true) {
    return "YES";
  }

  if (value === false) {
    return "NO";
  }

  const normalized = normalizeToken(value);

  if (["YES", "Y", "TRUE"].includes(normalized)) {
    return "YES";
  }

  if (["NO", "N", "FALSE"].includes(normalized)) {
    return "NO";
  }

  return "";
};

export const toYesNoDisplayValue = (value) => {
  // Handle boolean values directly
  if (value === true) {
    return "Yes";
  }
  if (value === false) {
    return "No";
  }

  const normalized = normalizeYesNo(value);

  if (normalized === "YES") {
    return "Yes";
  }

  if (normalized === "NO") {
    return "No";
  }

  return "";
};

export const toYesNoStoredValue = (value) => {
  // Convert to boolean for storage
  return toBooleanValue(value);
};

export const toBooleanValue = (value) => {
  const normalized = normalizeYesNo(value);

  if (normalized === "YES") {
    return true;
  }

  if (normalized === "NO") {
    return false;
  }

  return null;
};
